import CustomBackButton from "@/components/custom/custom-back-button";
import { DataTable } from "@/components/custom/data-table";
import { useAdminRoles } from "@/hooks/use-admin-role";
import { Box, Stack, styled, Typography } from "@mui/material";
import { RoleColumns } from "./_components/role-column";
import { useState } from "react";
import { CustomButton } from "@/components/custom/custom-button";
import NewRoleDialog from "./_components/new-role-dialog";
import { createAdminRole } from "@/services/role-access.service";

const SectionRoot = styled("section")(({ theme }) => ({
  margin: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Card = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "16px 20px",
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const ManageAdminRoles = () => {
  const [newRoleOpen, setNewRoleOpen] = useState(false);
  const { data: roles, isLoading, isError } = useAdminRoles();

  return (
    <SectionRoot>
      <Box display="flex" alignItems="center" gap={1.5}>
        <CustomBackButton />
        <Typography fontWeight={500} fontSize={18}>
          Admin Roles
        </Typography>
      </Box>
      <Card>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box />
          <CustomButton
            onClick={() => setNewRoleOpen(true)}
            sx={{ height: 35 }}
          >
            Add Role
          </CustomButton>
        </Stack>

        <DataTable
          columns={RoleColumns}
          data={roles?.data ?? []}
          isLoading={isLoading}
          isError={isError}
        />
      </Card>

      <NewRoleDialog
        open={newRoleOpen}
        onClose={() => setNewRoleOpen(false)}
        mutationFn={createAdminRole}
      />
    </SectionRoot>
  );
};

export default ManageAdminRoles;
